import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "text-muted"
}

import DataTable from '../components/tables/DataTable.vue';
import type { DataTableColumn } from '../components/tables/types';
import { EPINIO_TYPES } from '../types';
import LinkDetail from '@shell/components/formatter/LinkDetail.vue';
import BadgeStateFormatter from '@shell/components/formatter/BadgeStateFormatter.vue';

import { useStore } from 'vuex';
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { startPolling, stopPolling } from '../utils/polling';


export default /*@__PURE__*/_defineComponent({
  __name: 'configurations',
  props: {
    schema: {}
  },
  setup(__props: any) {

const store = useStore();

 // Keep for compatibility

const pending = ref<boolean>(true);

onMounted(async () => {
  store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.APP });
  store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.SERVICE_INSTANCE });
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.CONFIGURATION });

  pending.value = false;
  startPolling([
    "applications",
    "namespaces",
    "appcharts",
    "configurations",
    "services"
  ], store);
});

onUnmounted(() => {
  stopPolling([
    "applications",
    "namespaces",
    "appcharts",
    "configurations",
    "services"
  ]);
});

const rows = computed(() => {
  return store.getters['epinio/all'](EPINIO_TYPES.CONFIGURATION);
});

const columns: DataTableColumn[] = [
  {
    field: 'nameDisplay',
    label: 'Name'
  },
  {
    field: 'boundApps',
    label: 'Bound Applications',
    sortable: false
  },
  {
    field: 'service',
    label: 'Service',
    sortable: false
  },
  {
    field: 'variableCount',
    label: 'No. of Variables'
  },
  {
    field: 'configuration.user',
    label: 'Created By'
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTable, {
    rows: rows.value,
    columns: columns,
    loading: pending.value
  }, {
    "cell:stateDisplay": _withCtx(({ row }) => [
      _createVNode(BadgeStateFormatter, {
        row: row,
        value: row.stateDisplay
      }, null, 8, ["row", "value"])
    ]),
    "cell:nameDisplay": _withCtx(({ row }) => [
      _createVNode(LinkDetail, {
        row: row,
        value: row.nameDisplay
      }, null, 8, ["row", "value"])
    ]),
    "cell:service": _withCtx(({ row }) => [
      (row.service)
        ? (_openBlock(), _createBlock(LinkDetail, {
            key: row.service.id,
            row: row.service,
            value: row.service.meta.name
          }, null, 8, ["row", "value"]))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, " "))
    ]),
    "cell:boundApps": _withCtx(({ row }) => [
      (row.applications && row.applications.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.applications, (app, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: app.id
              }, [
                _createVNode(LinkDetail, {
                  row: app,
                  value: app.meta.name
                }, null, 8, ["row", "value"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                (index < row.applications.length - 1)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: app.id + 'i'
                    }, ", "))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_3, " "))
    ]),
    _: 1,
    __: [1,2,3]
  }, 8, ["rows", "loading"]))
}
}

})